import { Component, OnInit } from '@angular/core';
import { Fase } from '../../_models/fase';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FaseService } from '../../_services/fase.service';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

@Component( {
  selector: 'app-fase-editar',
  templateUrl: 'fase-editar.component.html'
} )

export class FaseEditarComponent implements OnInit {

  carInformacionInicial = true;
  lisTodasFases: Fase[] = [];
  fase: Fase;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  tabSeleccionado = 'INFO';
  codExiste = false;

  constructor( private fasServicio: FaseService,
               private conServicio: ConfirmationService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private navServicio: NavService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      this.fasServicio.listado().subscribe( lisFases => {
        this.lisTodasFases = lisFases;
        this.fase = (params[ 'id' ]) ? lisFases.find( x => x.idFase == params[ 'id' ] ) : null;
        this.cargarFormulario();
        this.carInformacionInicial = false;
      } );
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idFase: [ this.fase ? this.fase.idFase : null ],
      codigo: [ this.fase ? this.fase.codigo : null, [ Validators.required ] ],
      nombre: [ this.fase ? this.fase.nombre : null, [ Validators.required ] ],
      indicadorInicial: [ this.fase ? this.fase.indicadorInicial : false ],
      indicadorHabilitado: [ this.fase ? this.fase.indicadorHabilitado : true ],
      codigoShivam: [ this.fase ? this.fase.codigoShivam : null ],
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid && !this.codExiste ) {
      this.guardando = true;
      const registro = this.formulario.value;
      if ( registro.indicadorInicial ) {
        const exiInicial = this.lisTodasFases.find( x => x.indicadorInicial && x.idFase !== registro.idFase );
        if ( exiInicial ) {
          this.conServicio.confirm( {
            message: this.navServicio.buscarMensaje( 'FASES.MSG_EXISTEINICIAL' ),
            header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
            icon: 'fa fa-question-circle',
            key: 'fase',
            accept: () => {
              exiInicial.indicadorInicial = false;
              this.fasServicio.actualizar( exiInicial ).subscribe( actualizo => {
                this.guardar( registro );
              } );
            },
            reject: () => {
              this.guardando = false;
            }
          } );
        } else {
          this.guardar( registro );
        }
      } else {
        this.guardar( registro );
      }
    }
  }

  guardar( registro: any ) {
    if ( registro.idFase ) {
      this.fasServicio.actualizar( registro ).subscribe( rta => {
        this.fase = registro;
        this.salir( 2 );
      } );
    } else {
      this.fasServicio.crear( registro ).subscribe( rta => {
        this.f.idFase.setValue( rta.idFase );
        registro.idFase = rta.idFase;
        this.fase = registro;
        this.salir( 1 );
      } );
    }
  }

  salir( tipo: number ) {
    this.navServicio.setMesage( tipo );
    this.formulario.markAsPristine();
    this.tabSeleccionado = 'RELACIONES';
    this.guardando = false;
  }

  get f() {
    return this.formulario.controls;
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'fase',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo() {
    this.codExiste = this.lisTodasFases.find( x => x.codigo == this.f.codigo.value && x.idFase !== this.f.idFase.value ) ? true : false;
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'RELACIONES';
        break;
      }
      default: {
      }
    }
  }


}
